module.exports = __webpack_public_path__ + "img/logo2.b56a98da.png";